/** Price fields a work carries on GET /work-orders/:id and in the catalog (#1983). */
export interface FixedPriceFields {
  pricingType?: string | null;
  fixedPriceCents?: number | null;
  fixedPriceOverrideCents?: number | null;
}

/**
 * Whether the work bills as one fixed price, the rule the invoice applies
 * (`resolvedFixedPriceCents` in staff-api): a fixed catalog service with an
 * override or a positive catalog price. Its labor rows are locked (#3655); a
 * fixed service priced 0 bills its components and keeps editable labor.
 */
export function isFixedPricePackage(service: FixedPriceFields): boolean {
  if (service.pricingType !== 'fixed') return false;
  return service.fixedPriceOverrideCents != null || (service.fixedPriceCents ?? 0) > 0;
}
